import PropTypes from 'prop-types';

import React from 'react';

import FileUpload from '../ui/FileUpload';
import StyledDropzone from '../ui/StyledDropzone';
import IconUploadType from '../ui/IconUploadType';

export default function ImageUpload(props) {
  return (
    <FileUpload>
      <StyledDropzone
        className="uploadDropZone"
        accept="image/*"
        multiple={false}
        minSize={100}
        maxSize={10 * 1024 * 1024}
        onDrop={props.onDropFile}
      >
        <div className="uploadType">
          <IconUploadType />

          {props.titles.uploadDialog}
        </div>
      </StyledDropzone>
    </FileUpload>
  );
}

ImageUpload.propTypes = {
  titles: PropTypes.shape({
    drag: PropTypes.node,
    uploadDialog: PropTypes.node,
  }),
  onDropFile: PropTypes.func,
};

ImageUpload.defaultProps = {
  titles: {
    drag: '',
    uploadDialog: '',
  },
};
